import React, { Component } from 'react';
import comment_author from './../../../assets/comment_author.svg';
import {canDeleteComment} from './../../../utils/privacySettings';
import moment from 'moment';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import {Dropdown,DropdownMenu,DropdownToggle} from 'reactstrap';
import { profilePicValidityCheck } from '../../../utils/constants';

class CommentsList extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      dropdownOpen : []
    }
  }

  toggle = (id) => {
    const {dropdownOpen} = this.state;
    const index = findIndex(dropdownOpen,{id : id});
    if(index > -1) {
      dropdownOpen.splice(index,1);
    } else {
      dropdownOpen.push({id : id});
    }
    this.setState({dropdownOpen : dropdownOpen});
  }

  render() { 
    const {comments,totalComments,currentUser,chartOwner} = this.props;
    const {dropdownOpen} = this.state;
    return ( 
      <div>
        {
          comments.map((comment) => {
            return(
              <div key={comment._id} style={{marginTop:'15px'}}>
                <div className="row" style={{marginBottom:'5px'}}>
                  <div className="col-lg-8 col-md-8">
                    <img src={(comment.userId && profilePicValidityCheck(comment.userId.profilePic))? comment.userId.profilePic : comment_author} 
                      style={{height:'22px',width:'22px', borderRadius: '50%', objectFit:'cover'}}/>
                    <span style={{color:'#F06292',fontWeight:'600',fontSize:'14px',
                    marginLeft:'10px',lineHeight:'19px'}}>
                    {
                      !comment.userId || comment.userId.isDeleted ?
                       `Deleted User` : `${comment.userId.firstName} ${comment.userId.lastName}`
                    }
                    </span>
                  </div>
                  <div className="col-lg-4 col-md-4 text-right delCommentWrapper"
                  style={{display : canDeleteComment(currentUser,chartOwner,comment) ? 'initial' : 'none'}}
                  >
                    <Dropdown isOpen={(find(dropdownOpen,{id : comment._id}) != undefined)} 
                      toggle={() => this.toggle(comment._id)}>
                      <DropdownToggle
                        tag="span"
                        className="chart-item-menu"
                        onClick={this.toggle}
                        data-toggle="dropdown"
                        style={{cursor:'pointer'}}
                        aria-expanded={this.state.dropdownOpen}
                        >
                        <i className="comment-item flaticon-menu"></i>
                      </DropdownToggle>
                      <DropdownMenu className="comment-dropdown analytics">
                        <div className="row" style={{paddingLeft:'32px'}} 
                          onClick={() => this.props.onDeleteComment(comment._id)}>
                            <i className="chart-item-menu flaticon-minus"></i>
                            <span style={{color:'#FFFFFF',fontSize:'13px',marginLeft:'21px',
                              marginTop:'4px',cursor:'pointer'}}>
                              Delete Comment
                            </span>
                        </div>
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                </div>
                <div className="comment-value-container">
                  {comment.text}
                </div>
                <div className="comment-date-container">
                  {moment(comment.date).format("MMMM Do, YYYY hh:mmA")}
                </div>
              </div>
            )
          })
        }
        <div onClick={this.props.onSeeMoreComments} 
          style={{textAlign:'center',fontSize:'18px',lineHeight:'25px',
            display:comments.length === totalComments ? 'none' : 'block', color:'#5099DE',
            cursor:'pointer'}}>
          See more comments
        </div>
      </div>
    );
  }
}
 
export default CommentsList;